<template>
  <el-container class="mainContainer">
    <!--    顶栏容器-->
    <el-header class="wxHeader">
      <section class="topLogo" style="height: 100%; float: left; text-align: center; ">
        <img class="logo" src="../../../public/icon/Logo.png">
        <span class="logoText"> &nbsp; &nbsp;微信服务 </span>
      </section>
      <el-menu
          :default-active="1"
          class="headMenu"
          mode="horizontal"
          background-color="#0070C1"
          text-color="#fff"
          active-text-color="#ffd04b"
          @select="handleSelect"
      >
        <el-menu-item index="1" class="is-active">
          <img src="../../../public/icon/systemSetup.png">
          <span>&nbsp;&nbsp;设置中心</span>
        </el-menu-item>
      </el-menu>
    </el-header>

    <el-container class="sideContainer">
      <!--    侧边栏容器-->
      <el-aside class="wxAside">
        <el-menu
            active-text-color="#ffd04b"
            background-color="#545c64"
            class="el-menu-vertical-demo"
            default-active="/userManage"
            router="true"
            text-color="#fff"
            @open="handleOpen"
            @close="handleClose"
        >
          <el-menu-item index="/serviceIndex">
            <i class="el-icon-menu"></i>
            <span>微信服务配置</span>
          </el-menu-item>
          <el-menu-item index="/userManage">
            <i class="el-icon-setting"></i>
            <span>用户管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <!--    主要区域容器-->
      <el-main class="wxMain">
        <user-manage-table></user-manage-table>
      </el-main>
    </el-container>

  </el-container>
</template>

<script>
import UserManageTable from "../../components/userManagement/userManageTable";

export default {
  components: {UserManageTable},
  name: "userManageServer",
}
</script>

<style scoped>
.topLogo {
  height: 100%;
  float: left;
  text-align: center;
  display: flex;
  align-items: center;
  margin-right: 15px;
}

.wxHeader {
  background-color: #0070C1;
  height: 60px !important;
  display: inline-block;
}

.headMenu {
  margin-left: 5px;
}

.wxAside {
  width: 228px;
  height: 100%;
  background-color: #484B4F;
}

.mainContainer {
  height: 100%;
}

.logo {
  width: auto;
  height: 30px;
  line-height: 30px;
  max-width: 100%;
  max-height: 100%;
}

.logoText {
  color: white;
  height: 60px;
  line-height: 60px;
  font-size: 28px;
  font-family: Microsoft YaHei, sans-serif;
}
</style>